import { render, staticRenderFns } from "./ProfilePic.vue?vue&type=template&id=79158520&scoped=true&"
import script from "./ProfilePic.vue?vue&type=script&lang=js&"
export * from "./ProfilePic.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePic.vue?vue&type=style&index=0&id=79158520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79158520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
